import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    LaneGroup,
} from 'app/Apps/Pricing/Pricing.types'

import config from 'app/requests/ContractBasis/LaneGroup/LaneGroup.requests'

export default (id) => {
    return useRequest<LaneGroup>({
        key: RequestKeys.getContractBasisLaneGroupsDetails,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config.get),
        enabled: Boolean(id),
        staleTime: Infinity,
        keepPreviousData: true,
    })
}
